<template>
	<div class="incomeAll">
		<h6>服务购买记录</h6>

		<section class="system">
			<article class="table">
				<hgroup class="flex">
					<p></p>
					<p>订单号</p>
					<p>服务名称</p>
					<p>支付价格</p>
					<p>订购对象</p>
					<p>支付方式</p>
					<p>支付时间</p>
				</hgroup>
				<ul>
					<li class="flex zhong" v-for="(item, index) in list" :key="index">
						<div class="lia">
							<div class="img_box"><img :src="item.H5Cover" /></div>
						</div>
						<div class="lia">
							<p>{{item.No}}</p>
						</div>
						<div class="lia">
							<p>{{item.SaleName}}</p>
						</div>
						<div class="lia">
							<p>{{item.TotalPrice}}</p>
						</div>
						<div class="lia">
							<p>{{item.Phone}}</p>
						</div>
						<div class="lia">
							<p>{{item.PayWay==1?'微信':'支付宝'}}</p>
						</div>
						<div class="lia">
							<p>{{item.PayTime}}</p>
						</div>
					</li>
				</ul>
			</article>
			<div class="flex xend pageDiv">
				<el-pagination @current-change="GetList" :current-page.sync="page" :page-size="pageSize"
					layout="total, prev, pager, next, jumper" :total="totalCount">
				</el-pagination>
			</div>
		</section>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: [],
				page: 1,
				totle: 0,
				pageSize: 10
			};
		},
		created() {
			this.GetList(1);
		},
		methods: {
			GetList: function(page) {
				var that = this;
				that.$api.HtppRequest(
					'Card/Order?pageSize=' + that.pageSize + '&page=' + page,
					'GET', {},
					function(res) {
						console.log('获取列表');
						console.log(res);
						if (res.code === 0) {
							var list = res.data.list;
							var newList = page > 1 ? that.list : [];
							list.map(a => {
								newList.push(a);
							});
							that.list = newList;
							that.page = page;
							that.totle = res.data.TotalCount;
						}
						this.loading = false;
					},
					function(res) {}
				);
			}
		}
	};
</script>

<style scoped>
	.lia p {
		padding: 0 10px;
		box-sizing: border-box;
		font-size: 14px;
		text-align: center;
		color: #666666;
		position: relative;

	}

	.lia::after {
		content: '';
		width: 1px;
		height: 300%;
		background-color: #e6e6e6;
		position: absolute;
		right: 0;
		top: -30px;
		z-index: 0;
	}

	.lia {
		padding: 10px 0;
		width: calc(100% / 6);
		position: relative;
	}

	.lia:last-child::after {
		width: 0px;
	}

	.img_box img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.img_box {
		border-radius: 6px;
		width: 96px;
		height: 68px;
		margin: 0 auto;
		overflow: hidden;
		background: url(../../image/nob.png) no-repeat left top;
		background-size: 100% 100%;
	}

	/* img_box */

	.pageDiv {
		overflow: hidden;
		margin-top: 20px;
	}

	.table li p {
		font-size: 14px;
		text-align: center;
	}

	.table li {
		border-bottom: solid 1px #e6e6e6;
	}

	.table li:last-child {
		border-bottom: none;
	}

	.table li p:last-child {
		border-right: none;
	}

	.table ul {
		overflow: hidden;
	}

	.table hgroup p {
		font-size: 14px;
		background-color: #eaeaea;
		width: calc(100% / 6);
		line-height: 60px;
		text-align: center;
	}

	.table {
		overflow: hidden;
		border: solid 1px #e6e6e6;
		box-sizing: border-box;
	}

	.system {
		overflow: hidden;
		padding: 20px;
	}

	/* safety */

	.incomeAll>h6 {
		border-bottom: solid 1px #e6e6e6;
		font-size: 16px;
		color: #333;
		height: 62px;
		line-height: 62px;
		text-indent: 20px;
		position: relative;
	}

	.incomeAll>h6::after {
		content: '';
		width: 68px;
		height: 2px;
		background-color: #333;
		position: absolute;
		left: 20px;
		bottom: 0;
		z-index: 0;
	}

	.no-pdf {
		display: flex;
		justify-content: space-around;
		padding: 0 40px;
	}
</style>
